'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _apiHelper = require('api/api-helper');

var _selectors = require('selectors');

var _customersDataActions = require('actions/customersDataActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchCustomersData);

function fetchCustomersData() {
    var authToken, locale, customerIds, customersById, newCustomerIds, newCustomersData, errorMessage, i, error;
    return _regenerator2.default.wrap(function fetchCustomersData$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.take)(_customersDataActions.CUSTOMERS_DATA_REQUESTED);

                case 2:
                    _context.next = 4;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 4:
                    authToken = _context.sent;
                    _context.next = 7;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 7:
                    locale = _context.sent;
                    _context.next = 10;
                    return (0, _effects.select)(_selectors.getCustomerIds);

                case 10:
                    customerIds = _context.sent;
                    _context.next = 13;
                    return (0, _effects.select)(_selectors.getCustomersById);

                case 13:
                    customersById = _context.sent;


                    // ids of customers we need to fetch
                    // (because they did not have all the data we required (see selectors.js))
                    newCustomerIds = customerIds.filter(function (customerId) {
                        return !customersById[customerId];
                    });
                    // for each customer we need, call the api

                    _context.next = 17;
                    return newCustomerIds.map(function (customerId) {
                        return (0, _effects.call)(_apiHelper.getResourceData, customerId, 'customers', authToken, locale);
                    });

                case 17:
                    newCustomersData = _context.sent;
                    errorMessage = void 0;
                    i = 0;

                case 20:
                    if (!(i < newCustomersData.length)) {
                        _context.next = 28;
                        break;
                    }

                    error = newCustomersData[i].error;

                    if (!error) {
                        _context.next = 25;
                        break;
                    }

                    // Call to API for customerData fails
                    errorMessage = error._error;
                    return _context.abrupt('break', 28);

                case 25:
                    i++;
                    _context.next = 20;
                    break;

                case 28:
                    if (!errorMessage) {
                        _context.next = 33;
                        break;
                    }

                    _context.next = 31;
                    return (0, _effects.put)((0, _customersDataActions.customersDataRequestFailed)(errorMessage));

                case 31:
                    _context.next = 35;
                    break;

                case 33:
                    _context.next = 35;
                    return (0, _effects.put)((0, _customersDataActions.customersDataReceived)(newCustomersData.map(function (x) {
                        return x.resourceData;
                    })));

                case 35:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchCustomersData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchCustomersData.js
// module id = 1411
// module chunks = 0